module.exports = __webpack_public_path__ + "static/47-d043279cb434d08e86cfae089b6a3175.png";